const DAY_ORDER = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const SCHEDULE_NA = "N/A";

export type ServiceScheduleInput = {
  availableFromTime?: string | null;
  availableToTime?: string | null;
  availableDays?: readonly string[] | null;
};

const dayIndex = (day: string): number => {
  const index = DAY_ORDER.indexOf(day);
  return index === -1 ? DAY_ORDER.length : index;
};

/** Days sorted Mon..Sun joined with ", "; `na` when there are none. */
export function formatWorkingDays(
  days: readonly string[] | null | undefined,
  na: string = SCHEDULE_NA,
): string {
  if (!days?.length) return na;
  return [...days].sort((a, b) => dayIndex(a) - dayIndex(b)).join(", ");
}

/**
 * Schedule of a service for lists: "HH:MM–HH:MM, Mon, Tue" when present,
 * only the part that is set otherwise, `na` when there is no schedule.
 */
export function formatServiceSchedule(
  schedule: ServiceScheduleInput,
  na: string = SCHEDULE_NA,
): string {
  const { availableFromTime, availableToTime, availableDays } = schedule;
  const parts: string[] = [];
  if (availableFromTime && availableToTime) {
    parts.push(`${availableFromTime}–${availableToTime}`);
  }
  if (availableDays?.length) {
    parts.push(formatWorkingDays(availableDays, na));
  }
  return parts.length ? parts.join(", ") : na;
}
